import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { unsafeUseFormReturnSubset } from '@ipfabric/ui-components/utils/formSnippets/unsafeUseFormReturnSubset';
import { PrivilegedCredentials } from '../../../components/Authentication/PrivilegedCredentials';
import {
  type PrivilegedCredentialsFieldValues,
  storedPrivilegedCredentials,
} from '../../../snippets/storedPrivilegedCredentials';
import type { DiscoveryConfigWizardGroupDisplayControl } from '../DiscoveryConfigWizardPage1';

export const privilegedCredentialsGroup = createFormSnippetGroup({
  snippets: {
    storedPrivilegedCredentials,
  },
  render: ({ renderSnippet, form }) => (
    <PrivilegedCredentials
      form={unsafeUseFormReturnSubset(form)<
        keyof PrivilegedCredentialsFieldValues
      >()}
      renderSnippet={renderSnippet}
    />
  ),
  show: (control: DiscoveryConfigWizardGroupDisplayControl) => {
    control.setAuthenticationSubTab('privilegedCredentials');
  },
});
